import React, { useEffect, useState } from 'react';
import { getQuizzes } from '@/lib/api';
import { ManageQuizzes } from '@/components/quizzes/ManageQuizzes';

export default function NewQuizPage() {
  const [quizzes, setQuizzes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getQuizzes();
        setQuizzes(data || []);
      } catch (error) {
        console.error('Failed to fetch quizzes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-neutral-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <section>
        <h2 className="text-2xl font-semibold text-neutral-900">
          Create or Update Quiz
        </h2>
        <p className="mt-1 text-sm text-neutral-500">
          Draft localized prompts, configure scoring, and curate answer options.
          Select a quiz below to update it or start fresh with a new template.
        </p>
      </section>

      <ManageQuizzes initialQuizzes={quizzes} />
    </div>
  );
}

